<template>
    <div class="d-ins">
        <p>What is the probability that the cab involved in the accident was blue?</p>
        <p>You answered: <strong>{{ problem1 }}%</strong></p>
        <p>Later, your answer will be compared with the correct answer and the answers given by other participants. But first, click NEXT for another problem.</p>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['frame_no'],
  data () {
    return {
      range: '0'
    }
  },
  created () {
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'getData'
    ]),
    problem1 () {
      return this.getData('problem1')
    }
  },
  watch: {
  }
}
</script>
